import { createReducer } from 'reduxsauce';
import { request, success, failure, clear } from '../activateUseCase/reducer';
import { Types } from './actions';

export const INITIAL_STATE = {
  isLoading: false,
  isSuccess: false,
  error: null
};

export default createReducer(INITIAL_STATE, {
  [Types.CANCEL_CHANGE_PROGRAM_CAMPUS_MODALITY_REQUEST]: request,
  [Types.CANCEL_CHANGE_PROGRAM_CAMPUS_MODALITY_SUCCESS]: success,
  [Types.CANCEL_CHANGE_PROGRAM_CAMPUS_MODALITY_FAILURE]: failure,
  [Types.CANCEL_CHANGE_PROGRAM_CAMPUS_MODALITY_CLEAR]: clear
});
